export default __webpack_public_path__ + "140 Jahre Cashback-Aktion 2026 -Teilnahmebedingungen_Stand 09-26.pdf";